import React, { useEffect, useState } from 'react';
import { generateRssFeed } from '../services/rss';
const RSSFeed: React.FC = () => {
  const [rssContent, setRssContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchRss = async () => {
      try {
        const rss = await generateRssFeed();
        setRssContent(rss);
      } catch (err) {
        console.error('Error generating RSS feed:', err);
        setError('Failed to generate RSS feed');
      } finally {
        setLoading(false);
      }
    };
    fetchRss();
  }, []);
  // Display RSS content as preformatted text
  return <div className="container-custom py-12" data-id="element-1561">
      <h1 className="text-2xl font-bold text-navy mb-6 font-montserrat" data-id="element-1562">
        RSS Feed
      </h1>
      {loading ? <div className="flex justify-center py-8" data-id="element-1563">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-navy" data-id="element-1564"></div>
        </div> : error ? <div className="bg-red-50 text-red-700 p-4 rounded-md" data-id="element-1565">{error}</div> : <>
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-1566">
            <p className="mb-4" data-id="element-1567">
              You can subscribe to our RSS feed by adding the following URL to
              your RSS reader:
            </p>
            <div className="bg-gray-100 p-3 rounded-md font-mono text-sm break-all" data-id="element-1568">
              {window.location.origin}/rss.xml
            </div>
          </div>
          <div className="bg-gray-100 p-4 rounded-lg overflow-auto" data-id="element-1569">
            <pre className="text-xs text-gray-800" data-id="element-1570">{rssContent}</pre>
          </div>
        </>}
    </div>;
};
export default RSSFeed;